/**
 * Figma showcase product — split showcase card with a benefits accordion.
 *
 * Built as a Custom Element (Shopify's recommended pattern): the editor's
 * section re-renders are handled by the element lifecycle, no
 * `shopify:section:load` wiring needed.
 *
 * Each benefit tab owns a dedicated image (rendered by the section with
 * `data-benefit-index`). Clicking a benefit:
 * - activates its button (expands copy, fills the indicator, updates
 *   aria-expanded),
 * - shows the matching image and re-triggers its blur/fade animation.
 */
class FigmaShowcaseProduct extends HTMLElement {
  connectedCallback() {
    this.benefits = Array.from(this.querySelectorAll('[data-showcase-benefit]'));
    this.images = Array.from(this.querySelectorAll('[data-showcase-image]'));

    this.onClick = (event) => {
      const button = event.target.closest('[data-showcase-benefit]');
      if (button && this.contains(button)) this.activate(button);
    };
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  activate(button) {
    const index = this.benefits.indexOf(button);
    if (index === -1) return;

    this.benefits.forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-expanded', String(active));
    });

    this.images.forEach((image) => {
      const active = Number(image.dataset.benefitIndex) === index + 1;
      image.classList.toggle('is-active', active);
      image.setAttribute('aria-hidden', String(!active));

      if (active) {
        // Re-trigger the blur/fade animation.
        image.classList.remove('is-changing');
        void image.offsetWidth;
        image.classList.add('is-changing');
      }
    });
  }
}

if (!customElements.get('figma-showcase-product')) {
  customElements.define('figma-showcase-product', FigmaShowcaseProduct);
}
